import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { useBlocker } from 'react-router-dom';

//used to block peer analysis users from accessing pages that are not part of their allowed routes
//but will prevent any route change not in the allowed routes

export default function PreNavigationRouteBlockModal({ allowedRoutes, children }) {
  let blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return !allowedRoutes.some((route) => route.path.toLowerCase() === nextLocation.pathname.toLowerCase());
  });

  const handleClose = (e, reason) => {
    blocker.reset();
  };

  return (
    <>
      <Dialog open={blocker.state === 'blocked'} onClose={handleClose}>
        <DialogContent>
          <Typography align='center'>Your account currently does not have access to this page.</Typography>
          <Typography align='center'>
            If you would like to learn more, please contact your Hyperlift representative.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ textTransform: 'none' }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {children}
    </>
  );
}
